import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { v4 as uuidv4}  from 'uuid'
import pDebounce from 'p-debounce'

import { AutoCompleteWrapper, StyledAutocomplete, StyledBinIcon }  from './address-autocomplete.component.styles'
import { apiService } from '../api/api.service'
import { quoteTrackingService } from '../tracking.service'

const AddressAutocomplete = ({ placeholder, onChange, clickedEstimate, type }) => {
  const [t] = useTranslation()
  const errorMessage = t('textfield__error__please_enter_a_valid_address')
  const [value, setValue] = useState()
  const [touched, setTouched] = useState(false)
  const [error, setError] = useState(errorMessage)
  const previousTypedValue = useRef('')
  const sessionToken = useRef('')

  const debounceGetAddressSuggestions = pDebounce(apiService.getAddressSuggestions, 300)

  const handleQuery = async (value) => {
    sessionToken.current = sessionToken.current || uuidv4()
    try {
      const { predictions } = await debounceGetAddressSuggestions(value, sessionToken.current)
      const suggestions = predictions.map(prediction => ({
        value: prediction.placeid,
        label: prediction.address,
      }))

      return suggestions

    } catch (error) {
      console.log(error)
    }
  }

  const handleAutocompleteChange = async (selectedOption) => {
    if (selectedOption === null) {
      setValue()
      onChange(null)
      setError(errorMessage)
      return
    }

    const { value: placeid, label } = selectedOption

    setValue(selectedOption)

    const { latitude, longitude } = await apiService.getGeolocation(placeid, sessionToken.current)
    onChange({
      address: label,
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
    })
    sessionToken.current = ''
    setError('')
  }

  const handleClearIconClick = () => {
    handleAutocompleteChange(null)

    if(value) {
      quoteTrackingService.trackDeleteAddress({type, value: value.label})
    }
  }

  const meta = {
    touched : clickedEstimate || touched,
    error
  }

  const handleInputChange = (value) => {
    const startTyping = previousTypedValue.current === ''
    if(startTyping) {
      quoteTrackingService.trackAddressStartTyping(type)
    }

    previousTypedValue.current = value
  }

  return (
    <AutoCompleteWrapper onBlur={() => setTouched(true)}>
      <StyledAutocomplete
        placeholder={placeholder}
        displayKey="label"
        value={value}
        onQuery={handleQuery}
        onChange={handleAutocompleteChange}
        meta={meta}
        onInputChange={handleInputChange}
      />
      <StyledBinIcon onClick={handleClearIconClick} />
    </AutoCompleteWrapper>
  )
}

AddressAutocomplete.propTypes = {
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  clickedEstimate: PropTypes.bool,
  type: PropTypes.string.isRequired,
}

export { AddressAutocomplete }
